import { memo } from 'react';
import { useTheme } from '@mui/material';
import SurveyInstructionIllustrationLight from './surveyInstruction.svg?react';
import SurveyInstructionIllustrationDark from './surveyInstruction_dark.svg?react';

export const SurveyInstructionIllustration = memo(
  (props: React.SVGProps<SVGSVGElement>) => {
    const theme = useTheme();

    if (theme.palette.type === 'dark')
      return (
        <SurveyInstructionIllustrationDark aria-hidden="true" {...props} />
      );
    return <SurveyInstructionIllustrationLight aria-hidden="true" {...props} />;
  },
);
